<template>
    <div id="registryEditRulePanel" class="form-wrapper">

        <PanelDropdown v-model="localForm.registryHive" :label="$t('registryHive')" :options="registryHiveOptions"
            placeholder="None" :tooltip="tooltips.registryAccess.registryHive" />
        <FolderFileName v-model="localForm.registryKey" :max-length="260" :titleLabel="$t('registryKey')"
            :tooltip="tooltips.registryAccess.registryKey" placeholder="Enter Registry Key"
            :errorMessage="registryKeyError" :isInvalid="!!registryKeyError" @validation="onValidation" />
        <FolderFileName v-model="localForm.registryValue" :max-length="260" :titleLabel="$t('registryValue')"
            :tooltip="tooltips.registryAccess.registryValue" placeholder="Enter Registry Value"  />
        <PanelDropdown v-model="localForm.accessControl" :label="$t('accessControl')" :options="accessControlOptions"
            placeholder="" :tooltip="tooltips.registryAccess.accessControl" />
        <PanelDropdown v-model="localForm.appliesTo" :label="$t('appliesTo')" :options="appliesToOptions" placeholder=""
            :tooltip="tooltips.registryAccess.appliesTo" />
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" label="Expert Notes" />
    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import { useStore } from "@/store";
import ExpertNotes from './components/expertNotes.vue';
import tooltips from '@/assets/tooltips/en.json'
import FolderFileName from './components/folderFileName.vue';

const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'registry'
    },
    enumKey: {
        type: String,
        default: 'AccessControl'
    }
})
const emit = defineEmits(['update:form', 'validation'])
const store = useStore();
const registryKeyError = ref('');
const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

const accessControlOptions = computed(() => {
    return store.state.general.enums[props.enumKey] || [];
});

const appliesToOptions = computed(() => store.state.general.enums['AppliesTo'] || [])
const registryHiveOptions = computed(() => store.state.general.enums['RegistryHive'] || [])

const validateRegistryKey = (key) => {
    // if (!key) {
    //     return 'Registry key cannot be empty.';
    // }
    const forbiddenCharsRegex = /[/?"<>|]/;
    if (forbiddenCharsRegex.test(key)) {
        return 'Registry key name cannot contain the following characters: / ? " < > | or control characters.';
    }
    return '';
};

watch(() => localForm.value.registryKey, (newVal) => {
    registryKeyError.value = validateRegistryKey(newVal);
}, { immediate: true });

function onValidation(valid){
    emit('validation', valid)
}
</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 3px;
}
</style>
